import React, { Component } from "react";
import Pagination from "react-js-pagination";
import { FormControl, InputGroup, Button, Dropdown, Badge, OverlayTrigger, Tooltip } from 'react-bootstrap';
import SearchSharpIcon from "@material-ui/icons/SearchSharp";
import ArrowBackSharpIcon from "@material-ui/icons/ArrowBackSharp";
import MoreVertSharpIcon from "@material-ui/icons/MoreVertSharp";
import axiosRequest from 'axios';
import axios from '../../../axios';
import apiError from '../../../error';
import Loader from '../../../component/loader/loader';
import customSwal from '../../../customSwal';
import { toast } from 'react-toastify';
import { PiX, PiShield, PiInfo } from "react-icons/pi";
import InputRange from 'react-input-range';
import 'react-input-range/lib/css/index.css';
import '../campaign-list/campaign.css';
import { debounce, getDateWithoutTime } from "../../../function";
import { getStatusCount, getOverviewStatusMessages, getOverviewIconMeta } from "../../../component/campaigns/campaign-overview";
var cancelRequest = undefined, CancelToken = axiosRequest.CancelToken;
const HEALTH_DOT_GREEN_DARK = "#169c17";
const HEALTH_DOT_RED_DARK = "#b71c1c";

/** API may send 0–100 or a fraction in (0, 1); normalize to whole percent 0–100. */
const normalizeCampaignHealthPercent = (raw) => {
	if (raw === null || raw === undefined || raw === "") return null;
	const n = Number.parseFloat(String(raw).replace(/%/g, "").trim());
	if (!Number.isFinite(n)) return null;
	return Number(n);
};

export default class TestCampaign extends Component {

    constructor(props) {
        super(props);
        this.state = {
            type: '',
            count: 0,
            limit: 10,
            Expired: 7,
            search: '',
            activeId: null,
            campaigns: [],
            loading: true,
            activePage: 1,
            attackTypeId: '',
            attackTypes: [],
            simulationTypes: [],
            campaignType: '',
            filterPanelOpen: false,
            filterTab: 'attack-vector',
            healthMin: 0,
            healthMax: 100,
            filterDraftAttackTypeId: '',
            filterDraftCampaignType: '',
            filterDraftHealthMin: 0,
            filterDraftHealthMax: 100,
            hasAppliedFilters: false
        }
    }

    checkValidToken = () => {
        axios.post('/api/auth/check-token', {})
            .then(res => {
                this.load();
                this.loadAttackType();
                this.loadSimulationTypes();
            })
            .catch(err => apiError(err))
    }

    componentDidMount = () => {
        this.checkValidToken();
    }

    handleActiveCampaign = (campaignId) => {
        if (this.state.activeId === campaignId) {
            this.setState({ activeId: '' })
        } else {
            this.setState({ activeId: campaignId })
        }
    }

    nextPath = path => this.props.history.push(path + (path.indexOf('?') !== -1 ? '&' : '?') + 'from=test-campaign');

    /** Opens campaign edit with the same `campaign.health` as the test list row (CampaignEdit header). */
    pushToCampaignEdit = (campaign, simulationId) => {
        const sid = simulationId != null ? parseInt(simulationId, 10) : NaN;
        if (!campaign || campaign.id == null || !Number.isFinite(sid) || sid <= 0) return;
        this.props.history.push({
            pathname: `/campaign/${campaign.id}/${sid}`,
            search: "?from=test-campaign",
            state: { campaignListHealth: campaign.health },
        });
    };

    /** Same value as Health column (`campaign.health`); matches API minHealth/maxHealth. */
    getCampaignHealthRemaining = (campaign) => {
        if (campaign == null) return null;
        const h = campaign.health;
        if (h === null || h === undefined || h === "") return null;
        const n = Number(h);
        if (!Number.isFinite(n)) return null;
        return Math.min(100, Math.max(0, Math.round(n)));
    };

    handleDeleteCampaign = (e, campaignId) => {
        e.stopPropagation();
        customSwal({
            title: "Are you sure you want to delete this test campaign?",
            description: "This action cannot be undone.",
            icon: "warning",
            buttons: ["No", "Yes"],
            dangerMode: true,
        }).then((willDelete) => {
            if (willDelete) {
                axios.post('/api/campaigns/delete', { campaignIds: [campaignId] })
                    .then((res) => {
                        toast.success(res.data.message);
                        this.load();
                    })
                    .catch((err) => apiError(err));
            }
        });
    };

    setFilterTab = (filterTab) => this.setState({ filterTab });

    setHealthRange = (healthMin, healthMax) => {
        let min = Math.max(0, Math.min(100, parseInt(healthMin, 10) || 0));
        let max = Math.max(0, Math.min(100, parseInt(healthMax, 10) || 100));
        if (min > max) [min, max] = [max, min];
        this.setState({ healthMin: min, healthMax: max });
    };

    setDraftHealthRange = (healthMin, healthMax) => {
        let min = Math.max(0, Math.min(100, parseInt(healthMin, 10) || 0));
        let max = Math.max(0, Math.min(100, parseInt(healthMax, 10) || 100));
        if (min > max) [min, max] = [max, min];
        this.setState({ filterDraftHealthMin: min, filterDraftHealthMax: max });
    };

    applyFilters = () => {
        const draftType = String(this.state.filterDraftCampaignType ?? '').trim();
        const campaignType = this.state.simulationTypes.some(st => String(st.id) === draftType) ? draftType : '';
        this.setState({
            attackTypeId: this.state.filterDraftAttackTypeId || '',
            campaignType,
            healthMin: this.state.filterDraftHealthMin,
            healthMax: this.state.filterDraftHealthMax,
            filterPanelOpen: false,
            activePage: 1,
            hasAppliedFilters: true
        }, () => this.load());
    };

    getCampaignSimulationTypeId = (campaign) => {
        // Simulation type is stored on the simulation now (not the campaign template).
        const sim = campaign.simulations && campaign.simulations[0] ? campaign.simulations[0] : null;
        const simTypeId = sim ? (sim.simulation_type ? sim.simulation_type.id : sim.simulationTypeId) : null;
        return simTypeId != null ? String(simTypeId) : null;
    };

    getFilteredCampaigns = () => {
        const { campaigns, healthMin, healthMax, campaignType } = this.state;
        if (!campaigns || !campaigns.length) return [];
        return campaigns.filter((c) => {
            const healthVal = this.getCampaignHealthRemaining(c);
            if (healthVal !== null) {
                if (healthVal < healthMin || healthVal > healthMax) return false;
            }
            if (campaignType) {
                const simTypeId = this.getCampaignSimulationTypeId(c);
                if (String(simTypeId) !== String(campaignType)) return false;
            }
            return true;
        });
    };

    load = debounce(() => {
        if (cancelRequest) cancelRequest();
        this.setState({ loading: true });
        const params = {
            limit: this.state.limit,
            search: this.state.search,
            page: this.state.activePage,
            minHealth: this.state.healthMin,
            maxHealth: this.state.healthMax,
            campaignType: 'test'
        };
        if (this.state.attackTypeId) params.attackTypeId = this.state.attackTypeId;
        if (this.state.campaignType) params.simulationTypeId = this.state.campaignType;
        axios.get('/api/campaigns', {
            params,
            cancelToken: new CancelToken(function executor(c) { cancelRequest = c })
        })
            .then(async (res) => {
                await this.setState({
                    activeId: '',
                    loading: false,
                    count: res.data.count,
                    campaigns: res.data.campaigns,
                    Expired: parseInt(res.data.Expired, 10),
                })
            })
            .catch(error => {
                if (!axiosRequest.isCancel(error)) {
                    this.setState({ campaigns: [], count: 0, loading: false })
                    apiError(error);
                }
            })
    }, 500)

    loadAttackType = () => {
        axios.get('/api/attacktypes', {})
            .then(res => {
                this.setState({ attackTypes: res.data.attackTypes });
            })
            .catch(err => apiError(err))
    };

    loadSimulationTypes = () => {
        axios.get('/api/simulation/type', {})
            .then(res => {
                this.setState({ simulationTypes: res.data.simulation_type || [] });
            })
            .catch(err => apiError(err))
    }

    render() {
        const filteredCampaigns = this.getFilteredCampaigns();
        return (
            <div className="content-wrap">
                <div className="breadcrumbbar">
                    <div className="flexRow row">
                        <div className="col-md-4">
                            <div className="page-head d-flex align-items-center justify-content-between">
                                <h4 className="page-title">
                                    <a href="" onClick={(e) => { e.preventDefault(); this.props.history.push("/campaign"); }} className="bar_Icons mr-2">
                                        <ArrowBackSharpIcon className="btn-icon" />
                                    </a>
                                    Test Campaigns
                                    <OverlayTrigger placement="auto" overlay={<Tooltip id="test-campaigns">Test Campaigns are used to preview and validate campaign setups; analytics are not recorded.</Tooltip>}>
                                        <span className="d-inline-block ml-1" style={{ cursor: "pointer" }}>
                                            <PiInfo className="btn-icon" />
                                        </span>
                                    </OverlayTrigger>
                                </h4>
                            </div>
                        </div>
                        <div className="col-md-8 flexFilterButtons">
                            <div className="btn-container float-right d-flex align-items-center">
                                <OverlayTrigger placement="auto" overlay={<Tooltip id="test-campaigns">Contains records used to test templates before running a campaign.</Tooltip>}>
                                    <span className="d-inline-block ml-1" style={{ cursor: "pointer" }}>
                                        <Button
                                        variant="secondary"
                                            onClick={e => this.props.history.push('/campaign/test-results')}
                                        >
                                            Template Test Records
                                        </Button>
                                    </span>
                                </OverlayTrigger>

                            </div> 
                        </div>
                    </div>
                </div>

                <div className="contentbar campListGrids">
                    <div className="filter-without-border">
                        <div className="row align-items-center">
                            <div className="col-md-3">
                                <div className="positionSearchIcon">
                                    <InputGroup>
                                        <FormControl
                                            type="text"
                                            placeholder="Search"
                                            value={this.state.search}
                                            className="inputSearch mr-sm-2 form-control"
                                            onChange={(e) => this.setState({ search: e.target.value, activePage: 1 }, () => this.load())}
                                        />
                                        <SearchSharpIcon className="search-icon"></SearchSharpIcon>
                                    </InputGroup>
                                </div>
                            </div>
                            <div className="col-md-9">
                                <div className="rightFilters d-flex align-items-center">
                                    <Dropdown className="d-inline-block">
                                        <Dropdown.Toggle variant="secondary" id="limit-dropdown" className="dropdown-color-white mr-2">
                                            {this.state.limit}
                                        </Dropdown.Toggle>
                                        <Dropdown.Menu>
                                            {[10, 25, 50, 100].map((limit) => (
                                                <Dropdown.Item
                                                    key={`limit-${limit}`}
                                                    onClick={() => this.setState({ limit: limit, activePage: 1 }, () => this.load())}
                                                    active={this.state.limit === limit}
                                                >
                                                    {limit}
                                                </Dropdown.Item>
                                            ))}
                                        </Dropdown.Menu>
                                    </Dropdown>

                                    <Dropdown
                                        show={this.state.filterPanelOpen}
                                        onToggle={(isOpen) => this.setState({
                                            filterPanelOpen: isOpen,
                                            ...(isOpen ? {
                                                filterDraftAttackTypeId: this.state.attackTypeId,
                                                filterDraftCampaignType: this.state.campaignType,
                                                filterDraftHealthMin: this.state.healthMin,
                                                filterDraftHealthMax: this.state.healthMax
                                            } : {})
                                        })}
                                    >
                                        <Dropdown.Toggle variant="secondary" id="filter-dropdown" className="dropdown-color-white">
                                            Filter
                                        </Dropdown.Toggle>
                                        <Dropdown.Menu className="filter-panel-dropdown p-0" style={{ minWidth: '360px' }}>
                                            <div className="d-flex">
                                                <div className="filter-vertical-tabs border-right" style={{ width: '120px', minHeight: '220px' }}>
                                                    <button
                                                        type="button"
                                                        className={`d-block w-100 vertical-tab-item text-left ${this.state.filterTab === 'attack-vector' ? 'active' : ''}`}
                                                        style={{ fontSize: '13px' }}
                                                        onClick={() => this.setFilterTab('attack-vector')}
                                                    >
                                                        Attack Vector
                                                    </button>
                                                    <button
                                                        type="button"
                                                        className={`d-block w-100 vertical-tab-item ${this.state.filterTab === 'type' ? 'active ' : ''}`}
                                                        style={{ fontSize: '13px' }}
                                                        onClick={() => this.setFilterTab('type')}
                                                    >
                                                        Type
                                                    </button>
                                                    <button
                                                        type="button"
                                                        className={`d-block w-100 vertical-tab-item ${this.state.filterTab === 'health' ? 'active ' : ''}`}
                                                        style={{ fontSize: '13px' }}
                                                        onClick={() => this.setFilterTab('health')}
                                                    >
                                                        Health
                                                    </button>
                                                </div>
                                                <div className="filter-tab-content flex-grow-1" style={{ minHeight: '220px' }}>
                                                    {this.state.filterTab === 'attack-vector' && (
                                                        <>
                                                            <h6 className="mb-3 filter-heading">Select Attack Vector</h6>
                                                            <div className="filter-content-wrapper">
                                                                <FormControl
                                                                    as="select"
                                                                    value={String(this.state.filterDraftAttackTypeId ?? '')}
                                                                    className="form-control"
                                                                    onChange={(e) => this.setState({ filterDraftAttackTypeId: e.target.value || '' })}
                                                                >
                                                                    <option value="">All</option>
                                                                    {this.state.attackTypes.map((attack, index) => (
                                                                        <option key={'attack-' + index} value={String(attack.id)}>{attack.name}</option>
                                                                    ))}
                                                                </FormControl>
                                                            </div>
                                                        </>
                                                    )}
                                                    {this.state.filterTab === 'type' && (
                                                        <>
                                                            <h6 className="mb-3 filter-heading">Select Campaign Type</h6>
                                                            <div className="filter-content-wrapper">
                                                                <FormControl
                                                                    as="select"
                                                                    value={String(this.state.filterDraftCampaignType ?? '')}
                                                                    className="form-control"
                                                                    onChange={(e) => this.setState({ filterDraftCampaignType: e.target.value || '' })}
                                                                >
                                                                    <option value="">All</option>
                                                                    {this.state.simulationTypes.map((st, index) => (
                                                                        <option key={'campaign-type-' + index} value={String(st.id)}>{st.name}</option>
                                                                    ))}
                                                                </FormControl>
                                                            </div>
                                                        </>
                                                    )}
                                                    {this.state.filterTab === 'health' && (
                                                        <>
                                                            <h6 className="mb-3 filter-heading">Health Range</h6>
                                                            <div className="filter-content-wrapper">
                                                                <div className="health-range-slider-wrapper position-relative" style={{ paddingTop: '0px' }}>
                                                                    {/* <span className="health-range-tooltip" style={{ left: `${this.state.filterDraftHealthMin + 5}%`, transform: 'translateX(-50%)' }}>{this.state.filterDraftHealthMin}%</span>
                                                                    <span className="health-range-tooltip" style={{ left: `${this.state.filterDraftHealthMax - 7}%`, transform: 'translateX(-50%)' }}>{this.state.filterDraftHealthMax}%</span> */}
                                                                    <InputRange
                                                                        minValue={0}
                                                                        maxValue={100}
                                                                        value={{ min: this.state.filterDraftHealthMin, max: this.state.filterDraftHealthMax }}
                                                                        onChange={(value) => this.setDraftHealthRange(value.min, value.max)}
                                                                    />
                                                                </div>
                                                                <div className="filter-health-range-wrapper d-flex justify-content-between align-items-center">
                                                                    <p>{this.state.filterDraftHealthMin}% - {this.state.filterDraftHealthMax}%</p>
                                                                </div>
                                                            </div>
                                                        </>
                                                    )}
                                                </div>
                                            </div>
                                            <div className="filter-panel-footer p-2 border-top d-flex justify-content-end">
                                                <Button variant="primary" size="md" onClick={this.applyFilters}>Apply</Button>
                                            </div>
                                        </Dropdown.Menu>
                                    </Dropdown>
                                </div>
                            </div>
                        </div>
                    </div>

                    {this.state.hasAppliedFilters && (this.state.attackTypeId || this.state.campaignType || this.state.healthMin !== 0 || this.state.healthMax !== 100) && (
                        <div className="applied-filters-bar mt-2 mb-2 d-flex align-items-center flex-wrap">
                            {this.state.attackTypeId && (
                                <Badge variant="secondary" className="applied-filter-badge badge-soft-primary-filter d-inline-flex align-items-center mr-2">
                                    Attack Vector : {this.state.attackTypes.find(a => String(a.id) === String(this.state.attackTypeId))?.name || 'Attack Vector'}
                                    <PiX className="ml-1 filter-badge-close" onClick={() => this.setState({ attackTypeId: '' }, () => this.load())} />
                                </Badge>
                            )}
                            {this.state.campaignType && (
                                <Badge variant="secondary" className="applied-filter-badge badge-soft-primary-filter d-inline-flex align-items-center mr-2">
                                    Type : {this.state.simulationTypes.find(st => String(st.id) === String(this.state.campaignType))?.name || this.state.campaignType}
                                    <PiX className="ml-1 filter-badge-close" onClick={() => this.setState({ campaignType: '', activePage: 1 }, () => this.load())} />
                                </Badge>
                            )}
                            {(this.state.healthMin !== 0 || this.state.healthMax !== 100) && (
                                <Badge variant="secondary" className="applied-filter-badge badge-soft-primary-filter d-inline-flex align-items-center mr-2">
                                    Health : {this.state.healthMin}% - {this.state.healthMax}%
                                    <PiX className="ml-1 filter-badge-close" onClick={() => this.setState({ healthMin: 0, healthMax: 100, activePage: 1 }, () => this.load())} />
                                </Badge>
                            )}
                        </div>
                    )}

                    <div className="page-content p-0">
                        <div className="table-container-wrapper">
                            <table className="table mx-0">
                                <thead>
                                    <tr>
                                        <th className="width-30">Campaign</th>
                                        <th>Simulation Mode</th>
                                        <th>Primary Campaign Overview</th>
                                        <th>
											<span className="d-inline-flex align-items-center">
												Campaign Health
												<OverlayTrigger
													placement="top"
													overlay={
														<Tooltip id="campaign-health-header-tip">
															Represents the percentage of users who did not fall for the simulation, reflecting the overall remaining campaign health.
														</Tooltip>
													}
												>
													<span
														className="d-inline-flex align-items-center ml-1 campaign-health-header-info"
														tabIndex={0}
														aria-label="Campaign health: overall score across simulations; green when 80% or higher, red below."
														style={{ cursor: 'help' }}
														onClick={(e) => e.stopPropagation()}
													>
														<PiInfo size={15} className="text-muted" aria-hidden />
													</span>
												</OverlayTrigger>
											</span>
										</th>
                                        <th>Status</th>
                                        <th className="td-center">Action</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {this.state.loading ? (
                                        <tr>
                                            <td colSpan="6" className="text-center py-5">
                                                <Loader />
                                            </td>
                                        </tr>
                                    ) : filteredCampaigns.length ? (
                                        filteredCampaigns.map((campaign) => {
                                            const simulations = campaign.simulations ? campaign.simulations : [];
                                            // Type (simulation type) comes from the simulation now, not the template.
                                            const template = simulations[0] && simulations[0].simulation_type ? simulations[0].simulation_type.name : '---';
                                            const attackType = campaign.attack_type ? campaign.attack_type.name : '---';
                                            const simulationId = simulations[0] ? simulations[0].id : null;
                                            const healthPct = normalizeCampaignHealthPercent(campaign.health);
                                            const safeScore = healthPct !== null ? healthPct : 0;
                                            const filledDots = Math.min(10, Math.round((safeScore / 100) * 10));
                                            const filledDotColor = safeScore >= 80 ? HEALTH_DOT_GREEN_DARK : HEALTH_DOT_RED_DARK;
                                            return (
                                                <tr
                                                    key={'campaignlist-' + campaign.id}
                                                    className={campaign.id === this.state.activeId ? 'active tableGrid' : 'tableGrid'}
                                                    style={{ cursor: 'pointer' }}
                                                    onClick={() => simulationId && this.pushToCampaignEdit(campaign, simulationId)}
                                                >
                                                    <td className="text-ellipsis width-30">
                                                        <h6 style={{ fontSize: '14px', color: "#000" }}>{campaign.name.length > 30 ? campaign.name.slice(0, 30) + '...' : campaign.name}</h6>
                                                        <div className="d-flex align-items-center gap-2">
                                                            <p className="campaign-info">
                                                                {getDateWithoutTime(campaign.createdAt)}
                                                            </p>
                                                            <p className="campaign-info">&bull; {campaign.total} Users</p>
                                                            {/* <p className="campaign-info">&bull; {Math.max(0, simulations.length - 1)} Follow Up</p> */}
                                                        </div>
                                                    </td>
                                                    <td>
                                                        <Badge variant="primary" className="badge-soft-primary mr-2">{attackType}</Badge>
                                                        <Badge variant="primary" className="badge-soft-purple">{template}</Badge>
                                                    </td>
                                                    <td>
                                                        <div className="campaign-overview-icons">
                                                            {getOverviewStatusMessages(campaign).map((message) => {
                                                                const meta = getOverviewIconMeta(message, attackType);
                                                                const Icon = meta.Icon;
                                                                return (
                                                                    <OverlayTrigger
                                                                        key={message}
                                                                        placement="top"
                                                                        overlay={
                                                                            <Tooltip id={`overview-tip-${campaign.id}-${message}`}>
                                                                                {meta.label}
                                                                            </Tooltip>
                                                                        }
                                                                    >
                                                                        <div
                                                                            className={`campaign-overview-icon-item ${meta.colorClass}`}
                                                                            onClick={(e) => e.stopPropagation()}
                                                                        >
                                                                            <Icon />
                                                                            <span className="campaign-overview-icon-value">{getStatusCount(simulations.slice(0, 1), message)}</span>
                                                                        </div>
                                                                    </OverlayTrigger>
                                                                );
                                                            })}
                                                        </div>
                                                    </td>
                                                    <td>

                                                        <div className="evs-table-card__risk campaign-list-health-meter pr-0" style={{ minWidth: "0" }}>
                                                            <PiShield className="evs-table-card__risk-icon" />
                                                            <div className="evs-table-card__risk-dots">
                                                                {Array.from({ length: 7 }, (_, i) => (
                                                                    <span
                                                                        key={i}
                                                                        className={`evs-table-card__risk-dot ${i < filledDots ? "evs-table-card__risk-dot--filled" : ""}`}
                                                                        style={
                                                                            i < filledDots
                                                                                ? {
																						"--campaign-health-dot": filledDotColor,
																						backgroundColor: filledDotColor,
																				  }
                                                                                : undefined
                                                                        }
                                                                    />
                                                                ))}
                                                            </div>
                                                            <span
                                                                className="evs-table-card__risk-pct campaign-list-health-meter__pct"
                                                                style={
                                                                    healthPct !== null
                                                                        ? {
																				"--campaign-health-pct":
																					safeScore >= 80 ? HEALTH_DOT_GREEN_DARK : HEALTH_DOT_RED_DARK,
																		  }
                                                                        : undefined
                                                                }
                                                            >
                                                                {healthPct !== null ? `${healthPct}%` : "-"}
                                                            </span>
                                                        </div>
                                                    </td>
                                                    <td style={{
                                                        fontSize: "12px",
                                                        fontWeight: "600",
                                                        color: campaign.campaignStatus === "Completed" ? "#008000"
                                                            : campaign.campaignStatus === "Scheduled" ? "#6c757d" :
                                                                "#1967d1"
                                                    }}>{campaign.campaignStatus}</td>
                                                    <td className="td-center" onClick={(e) => e.stopPropagation()}>
                                                        <Dropdown className="action-dropdown dropdownIcon">
                                                            <Dropdown.Toggle className="btn-only" id={`dropdown-campaign-${campaign.id}`}>
                                                                <MoreVertSharpIcon className="dot-icon" />
                                                            </Dropdown.Toggle>
                                                            <Dropdown.Menu>
                                                                <Dropdown.Item onClick={e => this.pushToCampaignEdit(campaign, campaign.simulations[0].id)}>View</Dropdown.Item>
                                                                <Dropdown.Item onClick={(e) => this.handleDeleteCampaign(e, campaign.id)}>Delete</Dropdown.Item>
                                                            </Dropdown.Menu>
                                                        </Dropdown>

                                                    </td>
                                                </tr>
                                            );
                                        })
                                    ) : (
                                        <tr>
                                            <td colSpan="6" className="text-center">No Test Campaign Found</td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>

                            {this.state.campaigns && this.state.campaigns.length > 0 && filteredCampaigns.length > 0 && !this.state.loading && (
                                <div className="pagination-Wrap">
                                    <div className="row">
                                        <div className="col-md-6">
                                            <Pagination
                                                itemClass="page-item"
                                                linkClass="page-link"
                                                activePage={this.state.activePage}
                                                itemsCountPerPage={this.state.limit}
                                                totalItemsCount={this.state.count}
                                                onChange={(pageNumber) => this.setState({ activePage: pageNumber }, () => this.load())}
                                            />

                                        </div>
                                        <div className="col-md-6 text-right d-flex align-items-center footer-pg">
                                            <div className="w-100 pgCount">
                                                <p>{this.state.count === 0 ? 0 : this.state.activePage * this.state.limit + 1 - this.state.limit}-
                                                    {this.state.activePage * this.state.limit > this.state.count ? this.state.count : this.state.activePage * this.state.limit} of {this.state.count} records</p>
                                            </div>
                                        </div>
                                    </div>


                                    {this.state.loading && <Loader />}
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
